import createReducerExtended from 'utils/createReducerExtended';

import {
  CLEAR_ALL_ERRORS,
  CREATE_ERROR,
  DELETE_ERROR,
  REMOVE_FIRST_SHOWN_ERROR,
  SET_ERRORS_AS_SHOWN,
} from '../constants';
import { initialState } from '../schema';
import * as reduceClearAllErrors from './reduceClearAllErrors';
import * as reduceCreateError from './reduceCreateError';
import * as reduceDeleteError from './reduceDeleteError';
import * as reduceRemoveFirstShownError from './reduceRemoveFirstShownError';
import * as reduceSetErrorsAsShown from './reduceSetErrorsAsShown';

export const reducer = (state = initialState, action) =>
  createReducerExtended(
    state,
    action,
    {
      CLEAR_ALL_ERRORS,
      CREATE_ERROR,
      DELETE_ERROR,
      REMOVE_FIRST_SHOWN_ERROR,
      SET_ERRORS_AS_SHOWN,
    },
    {
      ...reduceCreateError,
      ...reduceDeleteError,
      ...reduceClearAllErrors,
      ...reduceSetErrorsAsShown,
      ...reduceRemoveFirstShownError,
    },
  );
